/**
 * ./version.yaml is generated by the "generateBuildNumber" script @see package.json
 */
import versionYaml from './version.yaml';

export default `${versionYaml.package}-${versionYaml.build}`;
